// extracted by mini-css-extract-plugin
module.exports = {"shadow-left":"styles_shadow-left__EbBvQ","shadow-right":"styles_shadow-right__1wGQa"};